export default __webpack_public_path__ + "35fe0a7b65c4152c24fe18e54e59f6a6.woff";